import { useState } from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button, Card, CardMedia, Chip, Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";

import awsLogo from "../../../../assets/aws-logo.svg";
import awsLogoDark from "../../../../assets/aws-logo-dark-mode.svg";
import Fsk8sPreviewDark from "../../../../assets/fsk8s/fsk8s-preview-dark.png";
import Fsk8sPreviewLight from "../../../../assets/fsk8s/fsk8s-preview-light.png";
import gcpLogo from "../../../../assets/gcp-logo.svg";
import { useDarkThemeCheck } from "../../../../Components/hooks/useDarkThemeCheck";
import { useIsFeatureEntitled } from "../../../../Context/TierProvider";
import { UpgradeOptions } from "../../../Upsell/UpgradeOptions";

const Overview = () => {
  const theme = useTheme();
  const isDarkTheme = useDarkThemeCheck();
  const customerHasEntitlement = useIsFeatureEntitled("lens:eks");

  const [showUpgradeOptions, setShowUpgradeOptions] = useState(false);

  const handleUpgradeOptionsClick = () => {
    setShowUpgradeOptions(true);
    // TODO: Implement metrics
  };

  return (
    <>
      <Grid container spacing={6}>
        <Grid
          size={{
            sm: 12,
            md: 6,
          }}
        >
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Typography variant="h1">Gain deep insights into your Kubernetes environment</Typography>
              <Stack direction="row" spacing={1}>
                <Chip
                  size="small"
                  icon={
                    <img
                      src={isDarkTheme ? awsLogoDark : awsLogo}
                      width={18}
                      alt="AWS Logo"
                      style={{ margin: "0 2px 0 8px" }}
                    />
                  }
                  label="EKS available"
                  sx={{ backgroundColor: theme.palette.general.backgroundDark, color: theme.palette.text.primary }}
                />
                <Chip
                  size="small"
                  icon={<img src={gcpLogo} width={18} alt="GCP Logo" style={{ margin: "0 0 0 8px" }} />}
                  label="GKE available"
                  sx={{ backgroundColor: theme.palette.general.backgroundDark, color: theme.palette.text.primary }}
                />
              </Stack>
            </Stack>
            <Typography variant="body1">
              <span>Quickly grasp the essential aspects of your Kubernetes environment with these key metrics:</span>
              <ul>
                <li>Cost Visibility: Understand your Kubernetes spending.</li>
                <li>Resource Monitoring: Track CPU and memory utilization.</li>
                <li>Workload Deep Dive: Explore deployment performance.</li>
                <li>Container-Level View: Analyze individual resource use.</li>
              </ul>
            </Typography>
            <Stack direction="row" spacing={2}>
              {!customerHasEntitlement && (
                <Button onClick={handleUpgradeOptionsClick} variant="contained" color="primary">
                  View upgrade options
                </Button>
              )}
              <Button
                variant="text"
                href="https://help.doit.com/docs/flexsave/kubernetes"
                startIcon={<OpenInNewIcon />}
                target="_blank"
              >
                Learn more
              </Button>
            </Stack>
          </Stack>
        </Grid>
        <Grid
          size={{
            sm: 12,
            md: 6,
          }}
        >
          <Card
            sx={{
              width: "100%",
              height: "fit-content",
              minHeight: 300,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "20px",
              boxShadow: 10,
            }}
          >
            <CardMedia
              component="img"
              image={isDarkTheme ? Fsk8sPreviewDark : Fsk8sPreviewLight}
              alt="Flexsave for Kubernetes Diagrams Preview"
              sx={{
                width: "100%",
                height: "auto",
              }}
            />
          </Card>
        </Grid>
      </Grid>
      <UpgradeOptions
        featureName="Flexsave for Kubernetes"
        open={showUpgradeOptions}
        onClose={() => {
          setShowUpgradeOptions(false);
        }}
        sendUpsellEvent={() => {
          // TODO: Implement metrics
        }}
      />
    </>
  );
};

export default Overview;
